import { flattenTags } from './flattenTags';
import { getFamilyIfManyTags } from './getFamilyIfManyTags';

export function getTagBySlug({ tags, slug }) {
  const flatTags = flattenTags(tags);

  const foundTag = flatTags.find(tag => tag?.slug === slug);

  return foundTag;
}

export function getManyTagsBySlug({ tags, slugs }) {
  const foundTags = slugs.map(slug => getTagBySlug({ tags, slug }));

  const filteredTags = foundTags.filter(Boolean);

  const reducedIfMany = getFamilyIfManyTags({
    tagsSubset: filteredTags,
    allTags: tags,
  });

  return reducedIfMany;
}
